function normalizePageName(pageName) {
  const normalized = String(pageName || "").trim().toLowerCase();

  if (normalized === "privacy policy") return "Privacy Policy";
  if (normalized === "terms of use") return "Terms of Use";
  if (normalized === "account removal") return "Account Removal";
  if (normalized === "support") return "Support";

  if (!normalized) return "Page";

  return normalized
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function buildSeoTitle(appName, pageName) {
  const app = String(appName || "").trim() || "GoodWave Lab";
  const page = normalizePageName(pageName);
  return `${app} - ${page} | GoodWave Lab`;
}
